/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ApplicationAnswersPatchFields } from './applicationAnswersPatchFields';

/**
 * Body for PATCH …/ats/application-answers.
 */
export interface ApplicationAnswersPatch {
  fields?: ApplicationAnswersPatchFields;
  apply_to_job_candidate_ids?: string[] | null;
}
